import { SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Input, Modal, Pagination, Select, Spin } from "antd";
import { useState } from "react";
import { type AuditLog, auditApi } from "../services/audit.api";

const actionOptions = [
	{ label: "Amal: barchasi", value: "all" },
	{ label: "sale", value: "sale" },
	{ label: "payment", value: "payment" },
	{ label: "room", value: "room" },
];

export function AuditPage() {
	const [actionFilter, setActionFilter] = useState("all");
	const [userQuery, setUserQuery] = useState("");
	const [selectedLog, setSelectedLog] = useState<AuditLog | null>(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);

	const { data, isLoading } = useQuery({
		queryKey: ["auditLogs", actionFilter, currentPage, pageSize],
		queryFn: () =>
			auditApi.getAuditLogs({
				entityType: actionFilter === "all" ? undefined : actionFilter,
				page: currentPage,
				limit: pageSize,
			}),
	});

	const rawItems = data?.items || [];
	const total = data?.total || 0;

	// Filter by user locally
	const filteredLogs = rawItems.filter((log) => {
		return log.user.toLowerCase().includes(userQuery.toLowerCase());
	});

	return (
		<div className="crm-audit-page">
			<div className="crm-page-head">
				<div>
					<h1>Audit jurnali</h1>
					<p>Muhim o'zgarishlar va foydalanuvchi amallari tarixi</p>
				</div>

				<div className="crm-audit-actions">
					<Select
						value={actionFilter}
						onChange={(val) => {
							setActionFilter(val);
							setCurrentPage(1);
						}}
						options={actionOptions}
					/>
					<Input
						allowClear
						prefix={<SearchOutlined />}
						placeholder="Foydalanuvchi"
						value={userQuery}
						onChange={(event) => setUserQuery(event.target.value)}
					/>
				</div>
			</div>

			{isLoading ? (
				<div style={{ padding: 100, textAlign: "center" }}>
					<Spin size="large" />
				</div>
			) : (
				<div className="crm-card crm-table-card crm-audit-table-card">
					<div className="crm-table-wrap">
						<table className="crm-table crm-audit-table">
							<thead>
								<tr>
									<th>Vaqt</th>
									<th>Foydalanuvchi</th>
									<th>Amal</th>
									<th>Obyekt</th>
									<th>IP</th>
								</tr>
							</thead>
							<tbody>
								{filteredLogs.length === 0 ? (
									<tr>
										<td
											colSpan={5}
											style={{ textAlign: "center", padding: "24px 0", color: "#999" }}
										>
											Ma'lumot mavjud emas
										</td>
									</tr>
								) : (
									filteredLogs.map((log) => (
										<tr key={log.id} onClick={() => setSelectedLog(log)}>
											<td className="crm-audit-time num">{log.time}</td>
											<td>
												<strong>{log.user}</strong>
											</td>
											<td>
												<span className={`crm-badge ${log.tone}`}>{log.action}</span>
											</td>
											<td className="num">{log.object}</td>
											<td className="crm-audit-ip num">{log.ip}</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
					<div
						className="crm-table-foot"
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							padding: "12px 24px",
						}}
					>
						<div style={{ color: "#888", fontSize: "13px" }}>
							{total > 0 ? "Tafsilotlarni ko'rish uchun qator ustiga bosing" : ""}
						</div>
						{total > 0 && (
							<Pagination
								current={currentPage}
								pageSize={pageSize}
								total={total}
								onChange={(page, size) => {
									setCurrentPage(page);
									setPageSize(size);
								}}
								size="small"
							/>
						)}
					</div>
				</div>
			)}

			<Modal
				open={Boolean(selectedLog)}
				onCancel={() => setSelectedLog(null)}
				footer={null}
				title="O'zgarish tafsiloti"
				width={560}
				className="crm-audit-modal"
			>
				{selectedLog ? (
					<div className="crm-audit-detail">
						<div className="crm-audit-kv">
							<span>Amal</span>
							<strong>{selectedLog.action}</strong>
						</div>
						<div className="crm-audit-kv">
							<span>Foydalanuvchi</span>
							<strong>{selectedLog.user}</strong>
						</div>
						<div className="crm-audit-kv">
							<span>Vaqt</span>
							<strong>{selectedLog.time}</strong>
						</div>

						<div className="crm-audit-diff-grid">
							<div>
								<div className="crm-audit-diff-title">old_data</div>
								<pre className="crm-audit-diff red">
									{selectedLog.oldData.length > 0 ? selectedLog.oldData.join("\n") : "bo'sh"}
								</pre>
							</div>
							<div>
								<div className="crm-audit-diff-title">new_data</div>
								<pre className="crm-audit-diff green">
									{selectedLog.newData.length > 0 ? selectedLog.newData.join("\n") : "bo'sh"}
								</pre>
							</div>
						</div>
					</div>
				) : null}
			</Modal>
		</div>
	);
}

export default AuditPage;
